import React,{useEffect} from 'react';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages';
import Discover from './pages/Discover';
// import MobileCard from './components/Discover/MobileCard';
import LuxRoom from './pages/LuxRoom';

import DeluxRoom from './pages/DeluxRooms';
import PremiumRoom from './pages/PremiumRoom';
import Amenities from './pages/Amenities';
import SignUp from './pages/SignUp';
import AvailableRooms from './pages/AvailableRooms';
// import FeatureCard from './components/AvailableRooms/AvailabilitiesCards/FeatureCard';
import CondCard from './components/AvailableRooms/AvailabilitiesCards/CondCard';
import {getPosts} from './actions/posts';
import {getHomePageContent} from './actions/homePagePosts';
import {getReview} from './actions/review';

import {useDispatch} from 'react-redux';

import DashboardPage from './pages/pagesAdminSide/DashboardPage';
import BookingPage from './pages/pagesAdminSide/Bookings';
import RoomAdminPage from './pages/pagesAdminSide/RoomAdmin';
import Webpages from './pages/pagesAdminSide/PagesAdmin';
import MediaAdminPage from './pages/pagesAdminSide/MediaAdmin';
import MessageAdminPage from './pages/pagesAdminSide/MessagesAdmin';
import ReviewsPage from './pages/pagesAdminSide/Reviews';
import SocialLinksPage from './pages/pagesAdminSide/SocialLinksAdmin';
import GalleryPage from './pages/Galleryp';
import SignInPage from './pages/SignInP';
import AuthPage from './pages/Authen';
import PlacesToVisitPage from './pages/PlacesToVisit';
import MaharajaSuitePage from './pages/MaharajaSuite';
import './fonts/century_751_semi_bold.ttf'; 
import './fonts/Weissenhof Grotesk W01 Regular.ttf'; 
import Thanks from './pages/Thanks';



function App() {
  const dispatch= useDispatch();
  const user = null;
  useEffect(()=>{
    dispatch(getHomePageContent());
    dispatch(getPosts());
    dispatch(getReview());
  },[dispatch]);

  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />}  />
        <Route path='/discover/' element={<Discover /> }  />
        <Route path='/luxroom/' element={<LuxRoom />}  />
        <Route path='/deluxroom/' element={<DeluxRoom />}  />
        <Route path='/premiumroom/' element={<PremiumRoom />}  />
        <Route path='/maharajasuite/' element={<MaharajaSuitePage />}  />
        <Route path='/amenities/' element={<Amenities />}  />
        <Route path='/signup/' element={<SignUp />}  />
        <Route path='/signin/' exact  element={user?<h4>Page not found</h4>:<SignInPage />}  />
        <Route path='/auth' element={<AuthPage />} />
        <Route path='/availablerooms/' element={<AvailableRooms />}  />
        <Route path='/gallery/' element={<GalleryPage />}  />
        <Route path='/thanks/' element={<Thanks />}  />
        <Route path='/placestovisit/' element={<PlacesToVisitPage />}  />
        <Route path='/availablerooms/CondCard' element={
          <div>
            
            <CondCard />
          </div>
        }  />
        
        <Route path='/admin/dashboard' element={<DashboardPage />} />
        <Route path='/admin/booking' element={<BookingPage />} />
        <Route path='/admin/room' element={<RoomAdminPage />} />
        <Route path='/admin/pagemanagement' element={<Webpages />} />
        <Route path='/admin/medias' element={<MediaAdminPage />} />
        <Route path='/admin/messages' element={<MessageAdminPage />} />
        <Route path='/admin/reviews' element={<ReviewsPage />} />
        <Route path='/admin/sociallinks' element={<SocialLinksPage />} />
        
        
        
      </Routes>
      
      
    </Router>
  );
}

export default App;
